import React from 'react';
import Helmet from 'react-helmet';

import Navbar from '../navbar';
import ProductSearchBar from './product-searchbar';
import { graphql, StaticQuery } from 'gatsby';
import styles2 from '../../styles/cities/header-search-bar.module.css';

class ProductHeader extends React.Component {
  constructor(props) {
    super(props);
    // this.city_data = props.data;
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          {
            site {
              siteMetadata {
                couponValue
                couponDescription
              }
            }
            images: allFile(
              filter: { extension: { regex: "/jpeg|jpg|png|gif/" } }
            ) {
              edges {
                node {
                  name
                  relativeDirectory
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const imageData = data.images.edges.find(image => {
            return (
              `${image.node.relativeDirectory}/${image.node.name}` ===
              '/product-page-header'
            );
          }).node.childImageSharp.gatsbyImageData;
          return (
            <>
              <div className="city-header">
                <Navbar />
                <div style={{ height: '500px' }}>
                  <Helmet>
                    <link
                      rel="preload"
                      as="image"
                      href={imageData.images.fallback.src}
                      imageSrcSet={imageData.images.fallback.srcSet}
                      imageSizes={imageData.images.fallback.sizes}
                    />
                  </Helmet>
                  <img
                    decoding="sync"
                    className={styles2.headerImage}
                    alt=""
                    src={imageData.images.fallback.src}
                    srcSet={imageData.images.fallback.srcSet}
                    sizes={imageData.images.fallback.sizes}
                  />
                  <div
                    style={{
                      position: 'relative',
                    }}
                  >
                    <ProductSearchBar
                      title={this.props.title}
                      subtitle={this.props.subtitle}
                    ></ProductSearchBar>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      />
    );
  }
}
export default ProductHeader;
